// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gN","advertCardPhoto__image":"c-a_gO"};